/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Billing_SubscriptionInputs */

const en_settings_billing_subscription = /** @type {(inputs: Settings_Billing_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current Subscription`)
};

const zh_settings_billing_subscription = /** @type {(inputs: Settings_Billing_SubscriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当前订阅`)
};

/**
* | output |
* | --- |
* | "Current Subscription" |
*
* @param {Settings_Billing_SubscriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_billing_subscription = /** @type {((inputs?: Settings_Billing_SubscriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_SubscriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_billing_subscription(inputs)
	return zh_settings_billing_subscription(inputs)
});
export { settings_billing_subscription as "settings.billing.subscription" }